import React, { useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Heading } from "uikit/components";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import styles from "./Popup.module.styl";

export default function Popup({
    children,
    title,
    titleClassName,
    header,
    name,
    onClose,
    appearance,
    overflow,
    closeOnClickOnOverlay,
}) {
    useEffect(() => {
        const initialOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = initialOverflow;
        };
    }, []);

    const onClickOverlay = (e) => {
        if (e.target === e.currentTarget) {
            closeOnClickOnOverlay && onClose && onClose();
        }
    };

    const hasHeader = title || header;

    return (
        <div className={styles.overlay} onClick={onClickOverlay}>
            <div
                className={cx(styles.container, styles["appearance_" + appearance])}
                data-test-name={name}
            >
                {onClose && <CloseIcon className={styles.closeIcon} onClick={onClose} data-test-name="popup-closeButton" />}

                {hasHeader && (
                    <div className={cx(styles.headerContainer)}>
                        <div className={titleClassName}>
                            {title && <Heading size="h2">{title}</Heading>}
                            {header}
                        </div>
                    </div>
                )}

                <div className={cx(styles.body, styles["overflow_" + overflow])}>{children}</div>
            </div>
        </div>
    );
}

Popup.propTypes = {
    title: PropTypes.string,
    titleClassName: PropTypes.string,
    header: PropTypes.node,
    name: PropTypes.string,
    onClose: PropTypes.func,
    appearance: PropTypes.oneOf(["big", "medium", "small", "adaptive"]),
    overflow: PropTypes.oneOf(["vertical-scroll", "visible"]),
    closeOnClickOnOverlay: PropTypes.bool,
};

Popup.defaultProps = {
    appearance: "big",
    overflow: "vertical-scroll",
    closeOnClickOnOverlay: false,
};
